import saMessages from '../locales/de_DE';

const saLang = {
    messages: {
        ...saMessages
    },
    locale: 'de-DE',

};
export default saLang;

